import TemplateCreate from "../../components/TemplateCreate";

export const ButtonEvents = {
    // Authentication related buttons
    LOGIN_BUTTON_CLICK: {id: 'BTN001', name: 'Login Button Click', category: 'auth'},
    SIGNUP_BUTTON_CLICK: {id: 'BTN002', name: 'Signup Button Click', category: 'auth'},
    LOGOUT_BUTTON_CLICK: {id: 'BTN003', name: 'Logout Button Click', category: 'auth'},

    // Social media related buttons
    CONNECT_TWITTER_CLICK: {id: 'BTN004', name: 'Connect Twitter Click', category: 'social'},
    CONNECT_LINKEDIN_CLICK: {id: 'BTN005', name: 'Connect LinkedIn Click', category: 'social'},
    POST_CREATE_CLICK: {id: 'BTN006', name: 'Create Post Click', category: 'social'},

    // Template related buttons
    TEMPLATE_CREATE_CLICK: {id: 'BTN007', name: 'Create Template Click', category: 'template'},
    TEMPLATE_EDIT_CLICK: {id: 'BTN008', name: 'Edit Template Click', category: 'template'},
    TEMPLATE_DELETE_CLICK: {id: 'BTN009', name: 'Delete Template Click', category: 'template'},

    // Subscription related buttons
    SUBSCRIBE_CLICK: {id: 'BTN010', name: 'Subscribe Click', category: 'subscription'},
    UPGRADE_PLAN_CLICK: {id: 'BTN011', name: 'Upgrade Plan Click', category: 'subscription'},

    // Navigation buttons
    NAV_DASHBOARD_CLICK: {id: 'BTN012', name: 'Dashboard Nav Click', category: 'navigation'},
    NAV_PROFILE_CLICK: {id: 'BTN013', name: 'Profile Nav Click', category: 'navigation'},

    // Waitlist related buttons
    WAITLIST_STATUS_CHECK: {id: 'BTN014', name: 'Waitlist Status Check', category: 'waitlist'},
    WAITLIST_STATUS_FOUND: {id: 'BTN015', name: 'Waitlist Status Found', category: 'waitlist'},
    WAITLIST_STATUS_NOT_FOUND: {id: 'BTN016', name: 'Waitlist Status Not Found', category: 'waitlist'},
    WAITLIST_STATUS_EXISTING_USER: {id: 'BTN017', name: 'Waitlist Status Existing User', category: 'waitlist'},
    WAITLIST_STATUS_ERROR: {id: 'BTN018', name: 'Waitlist Status Error', category: 'waitlist'},
};

export const AnalyticsEvents = {
    // Auth Events
    LOGIN_SUCCESS: {id: 'AUTH001', name: 'Login Success', category: 'auth'},
    LOGIN_FAILURE: {id: 'AUTH002', name: 'Login Failed', category: 'auth'},
    SIGNUP_SUCCESS: {id: 'AUTH003', name: 'Signup Success', category: 'auth'},
    SIGNUP_FAILURE: {id: 'AUTH004', name: 'Signup Failed', category: 'auth'},
    EMAIL_CONFIRMED: {id: 'AUTH005', name: 'Email Confirmed', category: 'auth'},
    PASSWORD_RESET_REQUESTED: {id: 'AUTH006', name: 'Password Reset Requested', category: 'auth'},

    // Social Connection Events
    SOCIAL_CONNECT_SUCCESS: {id: 'SOC001', name: 'Social Account Connected', category: 'social'},
    SOCIAL_CONNECT_FAILURE: {id: 'SOC002', name: 'Social Connection Failed', category: 'social'},

    // Post Events
    POST_CREATED: {id: 'POST001', name: 'Post Created', category: 'content'},
    POST_SCHEDULED: {id: 'POST002', name: 'Post Scheduled', category: 'content'},
    POST_PUBLISHED: {id: 'POST003', name: 'Post Published', category: 'content'},

    // Template Events
    TEMPLATE_CREATED: {id: 'TEMP001', name: 'Template Created', category: 'content'},
    TEMPLATE_EDITED: {id: 'TEMP002', name: 'Template Edited', category: 'content'},

    // Onboarding Events
    ONBOARDING_STARTED: {id: 'ONB001', name: 'Onboarding Started', category: 'onboarding'},
    ONBOARDING_COMPLETED: {id: 'ONB002', name: 'Onboarding Completed', category: 'onboarding'},
    ONBOARDING_STEP_COMPLETED: {id: 'ONB003', name: 'Onboarding Step Completed', category: 'onboarding'}
};

export const NavigationEvents = {
    NAV_PROFILE_CLICK: {id: 'NAV001', name: 'Profile Navigation', category: 'navigation'},
    NAV_DASHBOARD_CLICK: {id: 'NAV002', name: 'Dashboard Navigation', category: 'navigation'},
    NAV_POSTS_CLICK: {id: 'NAV003', name: 'Posts Navigation', category: 'navigation'},
    NAV_TEMPLATES_CLICK: {id: 'NAV004', name: 'Templates Navigation', category: 'navigation'},
    NAV_SETTINGS_CLICK: {id: 'NAV005', name: 'Settings Navigation', category: 'navigation'},
    NAV_LOGIN_CLICK: {id: 'NAV006', name: 'Login Navigation', category: 'navigation'},
    NAV_SIGNUP_CLICK: {id: 'NAV007', name: 'Signup Navigation', category: 'navigation'},
    NAV_LOGOUT_CLICK: {id: 'NAV008', name: 'Logout Click', category: 'navigation'},
    NAV_LOGO_CLICK: {id: 'NAV009', name: 'Logo Navigation', category: 'navigation'},
    MOBILE_MENU_OPEN: {id: 'NAV010', name: 'Mobile Menu Opened', category: 'navigation'},
    MOBILE_MENU_CLOSE: {id: 'NAV011', name: 'Mobile Menu Closed', category: 'navigation'}
};

export const ProfileEvents = {
    PROFILE_UPDATE_SUCCESS: {id: 'PROF001', name: 'Profile Update Success', category: 'profile'},
    PROFILE_BTN_CLICKED: {id: 'PROF001', name: 'Profile Button Click', category: 'profile'},
    PROFILE_UPDATE_FAILURE: {id: 'PROF002', name: 'Profile Update Failure', category: 'profile'},
    SOCIAL_CONNECTION_VIEW: {id: 'PROF003', name: 'Social Connections Viewed', category: 'profile'},
    BILLING_DETAILS_BTN_CLICKED: {id: 'PROF004', name: 'Billing Details Button Click', category: 'profile'},
    CONFLICT_DETECTION_SETTINGS_CHANGED: {id: 'PROF005', name: 'Conflict Detection Settings Changed', category: 'profile'}
};

export const ComposePostEvents = {
    POST_SUCCESS: {name: 'post success'},
    POST_FAILURE: {name: 'post failure'},
    SCHEDULE_POST_SUCCESS: {name: 'schedule post success'},
    SCHEDULE_POST_FAILURE: {name: 'schedule post failure'},
    MEDIA_UPLOAD_SUCCESS: {name: 'media upload success'},
    MEDIA_UPLOAD_FAILURE: {name: 'media upload failure'},
    SPELL_CHECK_TRIGGERED: {name: 'spell check triggered'},
    POST_NOW_CLICKED: {name: 'post now Button Click'},
    SCHEDULE_BUTTON_CLICKED: {name: 'schedule button Click'},
    POST_CLEAR_ALL_CLICKED: {name: 'Clear all text button Click'},
    UPLOAD_MEDIA_BTN_CLICKED: {name: 'Media Upload button Click'},
    GENERATE_MEDIA_BTN_CLICKED: {name: 'Generate Media Button Click'},
    ATTACH_MEDIA_BTN_CLICKED: {name: 'Attach Media button Click'},
    REMOVE_MEDIA_BTN_CLICKED: {name: 'Removed Attach Media button Click'},
    MOBILE_SELECT_SOCIAL_ACCOUNTS_BTN_CLICKED: {name: 'Select Account Dropdown Click'},
    SAME_TEXT_CHECKBOX: {name: 'Checked same text across all platforms'},
    SOCIAL_ACCOUNT_SELECTED: {name: 'Social Account Selected'},
    SOCIAL_ACCOUNT_DESELECTED: {name: 'Social Account Deselected'},
    MOBILE_SELECT_ACCOUNTS_DONE: {name: 'Mobile Account Selection Done'},

    // Retry and error handling events
    RETRY_OPERATION_START: {name: 'retry operation start'},
    RETRY_ATTEMPT: {name: 'retry attempt'},
    RETRY_SUCCESS: {name: 'retry success'},
    RETRY_EXHAUSTED: {name: 'retry exhausted'},
    CIRCUIT_BREAKER_STATE_CHANGE: {name: 'circuit breaker state change'},
    CIRCUIT_BREAKER_RESET: {name: 'circuit breaker reset'},
    ERROR_CLASSIFIED: {name: 'error classified'},
    NETWORK_ERROR_DETECTED: {name: 'network error detected'},
    RATE_LIMIT_DETECTED: {name: 'rate limit detected'},
};

/**
 * Enhanced Platform Service Events
 * Track interactions with the new Enhanced Platform Service
 */
export const EnhancedPlatformEvents = {
    // Service initialization and health
    SERVICE_INITIALIZED: { name: 'enhanced_platform_service_initialized', category: 'Enhanced Platform' },
    SERVICE_HEALTH_CHECK: { name: 'enhanced_platform_health_check', category: 'Enhanced Platform' },
    CAPABILITIES_FETCHED: { name: 'enhanced_platform_capabilities_fetched', category: 'Enhanced Platform' },
    
    // Validation events
    VALIDATION_ERROR_DETAILED: { name: 'enhanced_platform_validation_error_detailed', category: 'Enhanced Platform' },
    VALIDATION_WARNING: { name: 'enhanced_platform_validation_warning', category: 'Enhanced Platform' },
    VALIDATION_SUCCESS: { name: 'enhanced_platform_validation_success', category: 'Enhanced Platform' },
    
    // Post creation flow
    POST_TYPE_CHANGED: { name: 'enhanced_platform_post_type_changed', category: 'Enhanced Platform' },
    PLATFORM_SELECTION_CHANGED: { name: 'enhanced_platform_selection_changed', category: 'Enhanced Platform' },
    MEDIA_ATTACHMENT_ADDED: { name: 'enhanced_platform_media_added', category: 'Enhanced Platform' },
    MEDIA_ATTACHMENT_REMOVED: { name: 'enhanced_platform_media_removed', category: 'Enhanced Platform' },
    
    // Multi-platform posting
    MULTI_PLATFORM_POST_START: { name: 'enhanced_platform_multi_post_start', category: 'Enhanced Platform' },
    MULTI_PLATFORM_POST_SUCCESS: { name: 'enhanced_platform_multi_post_success', category: 'Enhanced Platform' },
    MULTI_PLATFORM_POST_FAILURE: { name: 'enhanced_platform_multi_post_failure', category: 'Enhanced Platform' },
    
    // Thread posting
    THREAD_POST_START: { name: 'enhanced_platform_thread_start', category: 'Enhanced Platform' },
    THREAD_POST_SUCCESS: { name: 'enhanced_platform_thread_success', category: 'Enhanced Platform' },
    THREAD_POST_FAILURE: { name: 'enhanced_platform_thread_failure', category: 'Enhanced Platform' },
    
    // Edit mode
    EDIT_MODE_INITIALIZED: { name: 'enhanced_platform_edit_mode_initialized', category: 'Enhanced Platform' },
    POST_UPDATE_SUCCESS: { name: 'enhanced_platform_post_update_success', category: 'Enhanced Platform' },
    POST_UPDATE_FAILURE: { name: 'enhanced_platform_post_update_failure', category: 'Enhanced Platform' },
    
    // Quick schedule
    QUICK_SCHEDULE_SELECTED: { name: 'enhanced_platform_quick_schedule_selected', category: 'Enhanced Platform' },
    
    // Conflict detection events
    SCHEDULING_CONFLICT_DETECTED: { name: 'scheduling_conflict_detected', category: 'Conflict Detection' },
    CONFLICT_SUGGESTION_SELECTED: { name: 'conflict_suggestion_selected', category: 'Conflict Detection' },
    CONFLICT_WINDOW_CHANGED: { name: 'conflict_window_changed', category: 'Conflict Detection' },
    CONFLICT_CHECK_FAILED: { name: 'conflict_check_failed', category: 'Conflict Detection' },
    DUPLICATE_CONTENT_WARNING: { name: 'duplicate_content_warning', category: 'Conflict Detection' },
    
    // Post reschedule events
    POST_RESCHEDULE_STARTED: { name: 'post_reschedule_started', category: 'Post Management' },
    POST_RESCHEDULE_SUCCESS: { name: 'post_reschedule_success', category: 'Post Management' },
    POST_RESCHEDULE_FAILURE: { name: 'post_reschedule_failure', category: 'Post Management' },
    RESCHEDULE_DIALOG_OPENED: { name: 'reschedule_dialog_opened', category: 'Post Management' },
    RESCHEDULE_DIALOG_CANCELLED: { name: 'reschedule_dialog_cancelled', category: 'Post Management' },
    
    // Optimal Times Insight Panel events
    INSIGHT_PANEL_TOGGLED: { name: 'optimal_times_insight_panel_toggled', category: 'Optimal Times' },
    MILESTONE_CLICKED: { name: 'optimal_times_milestone_clicked', category: 'Optimal Times' },
    INDUSTRY_INSIGHT_VIEWED: { name: 'optimal_times_industry_insight_viewed', category: 'Optimal Times' },
    PERSONALIZED_TIME_SELECTED: { name: 'optimal_times_personalized_time_selected', category: 'Optimal Times' },
    PROGRESS_MILESTONE_REACHED: { name: 'optimal_times_progress_milestone_reached', category: 'Optimal Times' },
};

export const ImageGalleryEvents = {
    CLOSE_DIALOG_BTN_CLICKED: {name: 'Close Image Galley Dialog Button Click'},
    SELECT_TEMPLATE_BTN_CLICKED: {name: 'Selected Template Button Click'},
    SELECT_NEW_TEMPLATE_BTN_CLICKED: {name: 'Select New Template Button Click'},
    UPLOAD_VIDEO_BTN_CLICKED: {name: 'Upload Video Button Click'},
    GENERATE_NEW_BTN_CLICKED: {name: 'Generating New Media Button Click'},
    PREVIEW_VIDEO_BTN_CLICKED: {name: 'Preview Video Button Click'},
    ADD_NEW_MEDIA_BTN_CLICKED: {name: 'Add Media to Post Button Click'},
    EDIT_NEW_MEDIA_BTN_CLICKED: {name: 'Edit New Media Button Click'},
    PROCESSING_VIDEO_BTN_CLICKED: {name: 'Processing Video Button Click'},
    PROCESSING_VIDEO_CLIP_ERROR: {name: 'Processing Clip Video Error'},
    PROCESSING_VIDEO_CLIP_SUCCESS: {name: 'Processing Clip Video Success'},
    PROCESSING_MEDIA_POLLING_SUCCESSFUL: {name: 'Polling Media Success'},
    PROCESSING_MEDIA_POLLING_ERROR: {name: 'Polling Media Error'},
    GIF_RADIO_SELECTED: {name: 'Select Gif Radio Click'},
    GIF_VIDEO_SELECTED: {name: 'Select Video Radio Click'},
};

export const EditorEvents = {
    LOADED_TEMPLATE_SUCCESSFULLY: {name: 'Editor Loaded Pre Save Template Successfully'},
    LOADED_TEMPLATE_ERROR: {name: 'Editor Loaded Pre Save Template Error'},
    SAVED_TEMPLATE_SUCCESSFULLY: {name: 'Editor Save Template Successfully'},
    SAVED_TEMPLATE_ERROR: {name: 'Editor Save Template Error'},
    SAVED_TEMPLATE_BTN_CLICKED: {name: 'Editor Save Template Button Click'},
    NEW_PAGE_BTN_CLICKED: {name: 'EditorNew Page Button Click'},
    BRANDED_TEMPS_BTN_CLICKED: {name: 'Editor Brande Templates Button Click'},
}

export const TemplateCreateEvents = {
    CLOSE_DIALOG_BTN_CLICKED: {name: 'Close Image Galley Dialog Button Click [Template Create Page]'},
    DOWNLOAD_MEDIA_BTN_CLICKED: {name: 'Download Media Button Click [Template Create Page]'},
    SELECT_TEMPLATE_BTN_CLICKED: {name: 'Selected Template Button Click [Template Create Page]'},
    SELECT_NEW_TEMPLATE_BTN_CLICKED: {name: 'Select New Template Button Click [Template Create Page]'},
    UPLOAD_VIDEO_BTN_CLICKED: {name: 'Upload Video Button Click [Template Create Page]'},
    GENERATE_NEW_BTN_CLICKED: {name: 'Generating New Media Button Click [Template Create Page]'},
    PREVIEW_VIDEO_BTN_CLICKED: {name: 'Preview Video Button Click [Template Create Page]'},
    CREATE_NEW_MEDIA_BTN_CLICKED: {name: 'Add Media to Post Button Click [Template Create Page]'},
    EDIT_NEW_MEDIA_BTN_CLICKED: {name: 'Edit New Media Button Click [Template Create Page]'},
    PROCESSING_VIDEO_BTN_CLICKED: {name: 'Processing Video Button Click [Template Create Page]'},
    PROCESSING_VIDEO_CLIP_ERROR: {name: 'Processing Clip Video Error [Template Create Page]'},
    PROCESSING_VIDEO_CLIP_SUCCESS: {name: 'Processing Clip Video Success [Template Create Page]'},
    PROCESSING_MEDIA_POLLING_SUCCESSFUL: {name: 'Polling Media Success [Template Create Page]'},
    PROCESSING_MEDIA_POLLING_ERROR: {name: 'Polling Media Error [Template Create Page]'},
    GIF_RADIO_SELECTED: {name: 'Select Gif Radio Click [Template Create Page]'},
    GIF_VIDEO_SELECTED: {name: 'Select Video Radio Click [Template Create Page]'},
}

export const PostRescheduleEvents = {
    POST_RESCHEDULE_STARTED: {
        name: 'post_reschedule_started',
        description: 'User started rescheduling a post'
    },
    POST_RESCHEDULE_SUCCESS: {
        name: 'post_reschedule_success', 
        description: 'Post was successfully rescheduled'
    },
    POST_RESCHEDULE_FAILURE: {
        name: 'post_reschedule_failure',
        description: 'Post reschedule failed'
    },
    RESCHEDULE_DIALOG_OPENED: {
        name: 'reschedule_dialog_opened',
        description: 'User opened the reschedule dialog'
    },
    RESCHEDULE_DIALOG_CANCELLED: {
        name: 'reschedule_dialog_cancelled',
        description: 'User cancelled the reschedule dialog'
    },
}

// Optimal Time Analytics Events
export const OptimalTimeAnalyticsEvents = {
    OPTIMAL_TIME_SUGGESTION_ACCEPTED: {
        name: 'optimal_time_suggestion_accepted',
        description: 'User accepted an optimal time suggestion',
        properties: ['platform', 'suggested_time', 'confidence_score', 'source']
    },
    OPTIMAL_TIME_SUGGESTION_REJECTED: {
        name: 'optimal_time_suggestion_rejected',
        description: 'User rejected an optimal time suggestion',
        properties: ['platform', 'suggested_time', 'confidence_score', 'reason']
    },
};

// Progressive Disclosure Events
export const ProgressiveDisclosureEvents = {
    INSIGHT_PANEL_TOGGLED: {
        name: 'insight_panel_toggled',
        description: 'User toggled the optimal times insight panel',
        properties: ['platform', 'expanded', 'stage', 'totalPosts']
    },
    MILESTONE_CLICKED: {
        name: 'milestone_clicked',
        description: 'User clicked on a milestone in the insight panel',
        properties: ['platform', 'milestone', 'unlocked', 'currentPosts']
    },
    INDUSTRY_INSIGHT_VIEWED: {
        name: 'industry_insight_viewed',
        description: 'User viewed industry insights for a platform',
        properties: ['platform', 'insightType']
    },
    PERSONALIZED_TIME_SELECTED: {
        name: 'personalized_time_selected',
        description: 'User selected a personalized optimal time',
        properties: ['platform', 'selectedTime', 'source', 'hour', 'minute', 'confidence']
    },
    PROGRESS_MILESTONE_REACHED: {
        name: 'progress_milestone_reached',
        description: 'User reached a new milestone in posting progress',
        properties: ['platform', 'milestone', 'totalPosts', 'timeToReach']
    },
};